/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, optimisticLockingOf, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { SalesTaxRateDto } from './sales-tax-rate.dto';
import { SalesTaxRateMapper } from './sales-tax-rate.mapper';

@Injectable()
export class SalesTaxRatesRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  /**
   * Grid data source for list of Take Off Params
   * @returns {SlicedDataSource<SalesTaxRateDto>}
   */
  findAllAsDataSource(): SlicedDataSource<SalesTaxRateDto> {
    return this.createSlicedDataSourceGet(
      `${this.bp}/sales-tax-rates`, void 0, void 0, arrayOf(SalesTaxRateMapper));
  }

  /**
   * Single Take Off Param Observable
   * @param id
   * @returns {Observable<SalesTaxRateDto>}
   */
  get(id: ID): Observable<SalesTaxRateDto> {
    return this.httpGet(`${this.bp}/sales-tax-rates/${id}`, optimisticLockingOf(SalesTaxRateMapper));
  }

  /**
   * Create new Take Off Param Observable
   * @param salesTaxRate
   * @returns {Observable<SalesTaxRateDto>}
   */
  create(salesTaxRate: SalesTaxRateDto): Observable<SalesTaxRateDto> {
    return this.httpPost(`${this.bp}/sales-tax-rates`, salesTaxRate, SalesTaxRateMapper);
  }

  /**
   * Update single Take Off Param Observable
   * @param salesTaxRate
   * @returns {Observable<SalesTaxRateDto>}
   */
  update(salesTaxRate: SalesTaxRateDto): Observable<SalesTaxRateDto> {
    const { id } = salesTaxRate;
    return this.httpPut(
      `${this.bp}/sales-tax-rates/${id}`, salesTaxRate, optimisticLockingOf(SalesTaxRateMapper));
  }
}
